import Skeleton from "react-loading-skeleton";

const UserProfileSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col bg-bg-base p-[16px] gap-[16px]">
      {/* Header */}
      <div className="flex flex-row w-full gap-[16px]">
        <div className="w-[50%]">
          <Skeleton height={40} borderRadius={8} />
        </div>
        <div className="w-[50%]">
          <Skeleton height={40} borderRadius={8} />
        </div>
      </div>
      <div className="flex flex-row w-full gap-[16px]">
        <div className="w-[50%]">
          <Skeleton height={40} borderRadius={8} />
        </div>
        <div className="w-[50%]">
          <Skeleton height={40} borderRadius={8} />
        </div>
      </div>
      <div className="flex flex-row w-full gap-[16px]">
        <div className="w-[50%]">
          <Skeleton height={40} borderRadius={8} />
        </div>
        <div className="w-[50%]">
          <Skeleton height={40} borderRadius={8} />
        </div>
      </div>
      <div className="flex flex-row w-full gap-[16px]">
        <div className="w-[50%]">
          <Skeleton height={40} borderRadius={8} />
        </div>
        <div className="w-[50%]">
          <Skeleton height={40} borderRadius={8} />
        </div>
      </div>
    </div>
  );
};

export default UserProfileSkeleton;
